module.exports = __webpack_public_path__ + "img/rz-logo.c84fc511.svg";